module.exports = __webpack_public_path__ + "img/login-form.fc284f44.png";